import React, { useState,useEffect, useContext } from 'react';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';

import UptimeGraph from './UptimeGraph';
import axios from 'axios';
import WatchMan from './WatchMan';
import ActivityLog from './ActivityLog';
import { addcontext } from '../../ContextShare/ContextShare';
import { Icon } from '@iconify/react/dist/iconify.js';
import { toast } from 'react-toastify';
import { ImportDumbApi } from '../../Services/allApi';



const DbStatus = () => {
  const [loading,setLoading]=useState(true)
  //logData stores data fetched from the json file
  const [logData, setLogData] = useState([]);
  const [timeChoice, setTimeChoice] = useState(30*24);
  const {selectedButton, setSelectedButton}=useContext(addcontext)

  const fetchLogData = async () => {
    
     //file time.json is read using axios call 
     //the response is the contents in the file
      await axios.get('/time.json',
      {headers:{
        'Content-Type':'application/json'
        
      }}
      ).then((response)=>{console.log(response.data)
        setLogData(response.data)
        setLoading(false)
      }
      ).catch((err)=>{console.log(err)})
      
  };
  
  useEffect(() => {

    fetchLogData();
  }, []);


    const handleToggle = () => {
        setSelectedButton(!selectedButton);
    };

    const handleCommandCopy=()=>{
      navigator.clipboard.writeText('psql -h hostname -p port -U username -d databasename -f filename.sql')
      toast.info("Command copied to clipboard")
    }

    const handleDownloadDumb=async()=>{
      const tokenn = sessionStorage.getItem('access_token');
          const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${tokenn}`
          };
      const res=await ImportDumbApi()
      console.log(res);
    //   if(res.status==200){
    //   const fileSql=res?.data?.data
    // }else{
    //   toast.error("There was a problem downloading dumb file")
    // }
  }
  return (
    <>
   
      <div className=' h-full w-full  flex justify-center '>
       <div className=' w-full '>

      {/* <div className='w-full flex justify-center'>
      <div className='flex flex-row bg-gray-200 p-1 border h-11 items-center justify-between rounded-full ms-10' style={{width:'26rem'}}>
                <button
                    className={`w-32 py-1 rounded-full  ${selectedButton=='ds'? 'bg-green-500 text-white font-bold' : ' text-gray-700 hover:bg-success'}`}
                    onClick={()=>setSelectedButton('ds')}
                >
                    Database Status
                </button>
                <button
                    className={`w-32 py-1 rounded-full  ${selectedButton=='cs'? 'bg-green-500 text-white font-bold' : ' text-gray-700 hover:bg-success'}`}
                    onClick={()=>setSelectedButton('cs')}
                >
                    Current Status
                </button>

                <button
                    className={`w-32 py-1 rounded-full ${selectedButton=='al'? 'bg-green-500 text-white font-bold' : ' text-gray-700 hover:bg-success'}`}
                    onClick={()=>setSelectedButton('al')}
                >
                    Activity Log
                </button>
            </div>
      </div> */}

       {selectedButton!='al'&&<h1 className='pt-5 pb-5 font-extrabold text-2xl ms-10'>{selectedButton=='ds'?'Database Status': selectedButton=='cs'?'Current Status':''}</h1>} 
       {selectedButton!='al'&&<hr className=' border-gray-400'/>}
       
       {selectedButton=='ds'?<>
       {/* <div className=' float-right mb-8 mt-10 w-32 h-10 border-2 bg-white rounded-md flex flex-row justify-evenly items-center'>
            <p className={` font-bold cursor-pointer ${timeChoice==24 ? "text-blue-800" : ""} `}  onClick={e=>setTimeChoice(24)} >24h</p>
            <p className={` font-bold cursor-pointer ${timeChoice==7*24 ? "text-blue-800" : ""} `} onClick={e=>setTimeChoice(7*24)}>7d</p>
            <p className={` font-bold cursor-pointer ${timeChoice==30*24 ? "text-blue-800" : ""} `} onClick={e=>setTimeChoice(30*24)}>30d</p>
        </div>
        <div className=' mt-10 w-full h-40 border-2 bg-white rounded-md border-gray-400 flex items-center justify-center ' style={{boxShadow: "0 8px 30px rgb(0,0,0,0.12)"}}>
          <div className='w-full h-2/4 ' >{
            loading ? <div className='flex items-center w-full h-full'> <p className='text-gray-600 font-bold text-lg'>Loading . . .</p> </div> :
            <UptimeGraph times={logData} choice={timeChoice}/>
          }
           </div>
        </div> */}
       <div className='flex flex-col p-5 gap-1 bg-yellow-700 shadow-lg border mx-2 rounded my-2'>
       {/* <div className=''>
          <button onClick={handleDownloadDumb} className='px-8 py-2 flex flex-row gap-1 bg-gray-100 rounded-xl text-blue-700 font-bold border border-blue-100 hover:text-white hover:bg-blue-700 items-center'><span>Download Database Dumb</span><Icon className='text-lg' icon="hugeicons:database-import" /></button>
        </div> */}
        <div className='flex flex-row gap-1 items-center h-full w-full underline'><span className='text-gray-900 font-bold text-xl'>Warning</span><Icon icon="ph:warning-light" className='text-gray-900 text-xl font-bold'/></div>

        {/* <div className='flex flex-row pt-2 text-lg'> */}
          {/* <p className='text-gray-600 font-bold'>Command For Importing Database:</p> */}
          {/* <p className='bg-green-50 ms-4 text-green-800 rounded-full px-2 border border-green-700'>psql -h  'hostname'  -p  'port'  -U 'username'  -d  'databasename'  -f  'filename'.sql</p> */}
          {/* <button className='text-gray-600 rounded-full border border-gray-800 px-2 ms-1 hover:bg-gray-300 bg-gray-100' onClick={handleCommandCopy}  */}
        {/* >copy</button> */}
        {/* </div> */}
        <div className='pt-2 flex flex-row items-center text-lg gap-2'>
          {/* <p className='text-gray-600 font-bold'>Note:</p> */}
          <p className='text-gray-900 '>
          It is the sole responsibility of the admin to ensure regular backups of the database are taken. Additionally, the admin must verify that the backup dumps can be successfully restored to create a new database when required. Failure to do so may result in data loss or service disruption
            </p></div>
       </div>
       </>
       :
       selectedButton=='cs'?
       <WatchMan/>
       :
      <ActivityLog/>
       }

      </div></div>
      </>
      
    
  );
};

export default DbStatus;